import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Swiper from 'react-id-swiper';
import { Link, useHistory } from 'react-router-dom';
import 'swiper/css/swiper.css';

import { Text } from '../../../components/common/atom/Text';
import { Flex } from '../../../components/common/atom/Layout';
import Icon from '../../../components/common/atom/Icon';
import { TextLink } from '../../../components/common/molecules/TextLink';
import SmallReviewCard from '../../../components/common/organism/SmallReviewCard';

import ThemeStyle from '../../../lib/style/ThemeStyle';
import * as PATH from '../../../lib/routes/path';
import { REVIEW } from '../../../components/common/template/PDPTemplate';
import { useGetReviewCount } from '../../../Hooks/useReview';
import EventReviewContestIcon from '../../../lib/image/event/EventReviewContestIcon';

const ReviewCarouselView = ({ data }) => {
  const [reviewCarousel, setReviewCarousel] = useState([]);
  const { reviewCount } = useGetReviewCount();

  const history = useHistory();

  useEffect(() => {
    if (data && Array.isArray(data.content)) setReviewCarousel(data.content);
  }, [data]);

  return (
    <Flex column alignItems="flex-start" padding={`1.25rem`} id={REVIEW}>
      <Flex column alignItems="flex-start" style={{ width: '100%' }}>
        <EventReviewContestIcon position="left" />
        <Flex justifyContent="space-between" width="100%">
          <Text weight="bold">리뷰 {reviewCount.toLocaleString()}건</Text>
          <Flex justifyContent="space-between">
            <TextLink size={12} color="orangePink" link={PATH.REVIEW}>
              전체보기 {`>`}
            </TextLink>
          </Flex>
        </Flex>
        <Text
          size={12}
          color="caption"
          style={{ margin: `0.5rem 0 0.1875rem` }}
        >
          배 속 아기를 미리 만나본 엄마 아빠의 행복 가득한 리뷰를 확인해보세요!
        </Text>
      </Flex>
      {history.location.pathname === '/' ? (
        // 메인
        <Swiper {...HOME_SWIPER_PARAMS}>
          {[0, 9].map((start) => (
            <GridContainer key={start}>
              {reviewCarousel.slice(start, start + 9).map((content) => (
                <Link
                  to={`${PATH.REVIEW_DETAIL}/${content.id}`}
                  key={content.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    background: ThemeStyle.background.grey,
                  }}
                >
                  <img
                    src={
                      content.facetImage !== null
                        ? content.facetImage.image.storageUri
                        : ''
                    }
                    alt="리뷰 이미지"
                    width="100%"
                    height="100%"
                    style={{ objectFit: 'cover' }}
                  />
                </Link>
              ))}
            </GridContainer>
          ))}
        </Swiper>
      ) : (
        <SwiperContainer>
          <Swiper {...SERVICE_SWIPER_PARAMS}>
            {reviewCarousel.map((content) => {
              const {
                id,
                facetImage,
                userName,
                createDateTime,
                likesCount,
                text,
                star,
              } = content;
              return (
                <div key={id}>
                  <SmallReviewCard
                    id={id}
                    storageUri={
                      facetImage !== null ? facetImage.image.storageUri : ''
                    }
                    userName={userName}
                    createDateTime={createDateTime}
                    likesCount={likesCount}
                    reviewText={text}
                    star={star}
                  />
                </div>
              );
            })}
          </Swiper>
        </SwiperContainer>
      )}
    </Flex>
  );
};

export default ReviewCarouselView;

const HOME_SWIPER_PARAMS = {
  shouldSwiperUpdate: true,
  spaceBetween: 30,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  renderPrevButton: () => (
    <CustomButton className="swiper-button-prev" prev>
      <Icon iconName="arrow_back_ios" />
    </CustomButton>
  ),
  renderNextButton: () => (
    <CustomButton className="swiper-button-next">
      <Icon iconName="arrow_forward_ios" />
    </CustomButton>
  ),
};

const SERVICE_SWIPER_PARAMS = {
  shouldSwiperUpdate: true,
  spaceBetween: 24,
  slidesPerView: 'auto',
};

const CustomButton = styled.div`
  background: rgba(22, 22, 22, 0.75);
  border-radius: ${(props) =>
    props.prev ? '0 100px 100px 0' : '100px 0 0 100px'};

  i {
    color: ${(props) => props.theme.background.white};
    margin-left: 10px;
  }
  &.swiper-button-next,
  &.swiper-button-prev {
    height: 3.75rem;
    width: 1.875rem;
  }
  &.swiper-button-next {
    right: 0;
  }
  &.swiper-button-prev {
    left: 0;
  }
  &.swiper-button-next:after,
  &.swiper-button-prev:after {
    display: none;
  }
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 0.3745rem;
  padding: 0.3125rem 0 1.25rem;

  &.swiper-slide {
    height: 20.937rem;
  }
`;

const SwiperContainer = styled.div`
  width: 100%;
  margin: 0.625rem 0 0;
  max-width: 566px;

  .swiper-container {
    height: 23.5rem;
  }

  .swiper-slide {
    width: auto;
  }
`;
